import { TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutPartialShipmentProfileLookup } from "./autogen/AutogenLayoutPartialShipmentProfileLookup";

export class PartialShipmentProfileLookup extends AutogenLayoutPartialShipmentProfileLookup {

    tablePartialShipmentProfileLookupOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        if (tableRow.index > 0) {
            tableRow.table.rows[tableRow.index - 1].borderBottomWidth = 1;
        }
    }
}
